export const TTXStateMessageRole = {
  USER: 'user',
  ASSISTANT: 'assistant',
  SYSTEM: 'system',
} as const;

export type TTXStateMessageRole = (typeof TTXStateMessageRole)[keyof typeof TTXStateMessageRole];
